import React from 'react'
import {createRefetchContainer, graphql} from 'react-relay'
import Table from './../../components/Table';
import {Staticview} from './../../components/Staticview';
import {ResponsibilityView} from './../../components/ResponsibilityView';
import SetupView from './../../components/SetupView';
import {setShowSetupForce, getShowSetupForce} from './../../tools/LocalStorageHandler'
import '../../scss/Screen.scss';
class Screen extends React.Component {

  state = { show: false };

  constructor(props) {
    super(props);
    this.currentScreenIndex = props.config.screenSequence[0];
    this.currentScreenSequenceIndex = 0;
    this.styles = false;
    this.state = { showFooter: true};
    this.nextScreen();

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    setShowSetupForce();
    window.location.reload();
  }

  skipHtmlScreenIfEmpty() {
    if(this.props.screen.contentType === 'HTML' && this.props.screen.html.trim() === "") {
      return 0;
    }
    return this.props.screen.duration * 1000;
  }

  nextScreen(timeout){
    if (this.currentScreenSequenceIndex === (this.props.config.screenSequence.length-1)) {
      this.currentScreenSequenceIndex = 0;
    }

    setTimeout(() => {
        this._refetch(this.props.config.screenSequence[this.currentScreenSequenceIndex]);
        this.currentScreenSequenceIndex++;
        this.setState({showFooter : true});
    }, timeout);
    setTimeout(() => {
        this.setState({showFooter : false});
    }, 2000);
  }

  _refetch = (index) => {
    this.props.relay.refetch({
      index: index
    }, // query variables
        null, () => {
          let timeout = this.skipHtmlScreenIfEmpty()
          this.nextScreen(timeout);
    }, {
      force: true
    },);
  };

  render() {
    console.log("show next screen now",this.props.screen.contentType);
    return (<div className="screenContainer">
      {
        (() => {
          if(this.props.screen.name === null || getShowSetupForce() !== null ){
            return <SetupView/>
          }
          else{
            switch (this.props.screen.contentType) {
              case 'ROWS':
                return <Table screen={this.props.screen} />
              case 'HTML':
                return <Staticview staticContent={this.props.screen.html} />
              case 'JSON':
                return <ResponsibilityView jsonData={JSON.parse(this.props.screen.json)} />
              default:

            }
          }
        })()
      }
      <div className={this.state.showFooter ? 'pageNameDisplay visible' : 'pageNameDisplay hidden'}>
            {this.props.screen.name}
      </div>
        <input
          className="setupButtonDisplay"
          type="button"
          value="Setup"
          onClick={this.handleClick}
        />
    </div>)
  }
}

export default createRefetchContainer(Screen, {
  screen: graphql `
            fragment Screen_screen on Screen {
              id,
              index,
              rowset {
                fields{
                  name,
                  label
                },
                rows
              },
              name,
              html,
              json,
              duration,
              contentType,
              dataSource
            }
        `,
  config: graphql `
            fragment Screen_config on InfoMonitorConfig {
                id
                screenConfigs{
                    index, name
                }
                screenSequence
            }`
}, graphql `
        query ScreenRefetchQuery($index: Int) {
            screen: screen(index: $index) {
                ...Screen_screen
            }
        }
    `)



// WEBPACK FOOTER //
// ./src/scenes/Screen/index.js